const IS_PRODUCTION=true;
const networkList = {
    'base_url':(IS_PRODUCTION)?'https://fc.kimshospitals.com:3000/':'https://testfc.kimshospitals.com:3000/',
    //'base_url':(IS_PRODUCTION)?'https://fc.kimshospitals.com:3000/':'http://10.18.129.11:3002/',
    //'base_url':'http://localhost:3003/',
    'otm_base_url': (IS_PRODUCTION) ? 'https://otm.kimshospitals.com:3000' :'https://testotm.kimshospitals.com:3000',
    'login': 'login',
    'queue_workflow': 'getProcessStages',
    'master_unit': 'getUnits',
    'master_department': 'getDepartments',
    'master_service': 'getServices',
    'master_doctor': 'getDoctors',
    'master_operator': 'getServiceOperators',
    'create_queue': 'createQueueConfig',
    'queue_list': 'getQueues',
    'queue_config': 'getQueueConfig',
    'getMasterPages': 'getMasterPages',
    'checkDuplicateRole': 'checkDuplicateRole',
    'createNewRole': 'createNewRole',
    'getRolesList': 'getRolesList',
    'getAccessLevels': 'getAccessLevels',
    'checkDuplicateUser': 'checkDuplicateUser',
    'createUser': 'createUser',
    'getRolePermissions': 'getRolePermissions',
    'getUsersList': 'getUsersList',
    'checkDuplicateTvDisplay': 'checkDuplicateTvDisplay',
    'getTvDisplays': 'getTvDisplays',
    'getQueueListDropDown': 'getQueueListDropDown',
    'getChemists': 'getChemists',
    'getDispatchers': 'getDispatchers',
    'addTvDisplay': 'addTvDisplay',
    'tvDisplayLogin': 'tvDisplayLogin',
    'getTvCounter': 'getTvCounter',
    'getTatReport': 'getTatReport',
    'getPlebos': 'getPlebos',
    'getAnomalyReport': 'getAnomalyReport',

    'getAppointmentSlots': 'getAppointmentSlots',
    'addAppointments': 'addAppointments',
    'disableAppointments': 'disableAppointments',
    'cancelAppointments': 'cancelAppointments',
    'createUnit': 'createUnit',
    'getDepartments': 'getDepartments',
    'createDepartment': 'createDepartment',
    'rescheduleAppointments': 'rescheduleAppointments',
    'getDepartmentsList': 'getDepartmentsList',
    'getServicesBasedOnUserId': 'getServicesBasedOnUserId',
    'CheckAppointmentToken': 'checkAppointments',
    'editUnit': 'editUnit',
    'editDepartment': 'editDepartment',
    'getServicesList': 'getServicesList',
    'editService': 'editService',
    'createService': 'createService',

    'editDoctor': 'editDoctor',
    'getMasterServicesList': 'getMasterServicesList',
    'createMasterService': 'createMasterService',
    'getMasterServices': 'getMasterServices',
    'checkPatientbill': 'checkPatientbill',
    'getQueueInfoById': 'getQueueInfoById',
    'getDisabledAppointmentSlots': 'getDisabledAppointmentSlots',
    'getAppointmentDoctorsById': 'getAppointmentDoctorsById',
    'getTvById': 'getTvById',
    'downloadTatReport': 'downloadTatReport',
    'updateTvDisplay': 'updateTvDisplay',
    'deleteDisabledAppointmentSlot': 'deleteDisabledAppointmentSlot',
    'updateUserDetailsById': 'updateUserDetailsById',
    'deleteTvDisplay': 'deleteTvDisplay',
    'editQueueConfig': 'editQueueConfig',
    'getTvCounterWithNoAuth': 'getTvCounterWithNoAuth',
    'getAppointmentBookingReasons': 'getAppointmentBookingReasons',
    'getPatientDetailsForApptSlot': 'getPatientDetailsForApptSlot',
    'getRoomsForAppointmentSlotBlocking': 'getRoomsForAppointmentSlotBlocking',
    'getPatientTypes': 'getPatientTypes',
    'getBlockedSlots': 'getBlockedSlots',
    'addBlockSlot': 'addBlockSlot',
    'deleteBlockedSlot': 'deleteBlockedSlot',
    'noShowReport': 'noShowReport',
    'getProcessStages': 'getProcessStages',
    'getNamesBasedonServiceIdUnitId': 'getNamesBasedonServiceIdUnitId',
    'getServiceNames': 'getServiceNames',
    'getAppointmentRescheduleReasons': 'getAppointmentRescheduleReasons',
    'getAllDoctorsDisplays': 'getAllDoctorsDisplays',
    'addQueueDoctor': 'addQueueDoctor',
    'getQueueDoctorById': 'getQueueDoctorById',
    'getQueueListBasedonUnit': 'getQueueListBasedonUnit',
    'addQueueDoctor': 'addQueueDoctor',
    'deleteQueueDoctor': 'deleteQueueDoctor',
    'updateQueueDoctor': 'updateQueueDoctor',
    // new Services
    'getDoctorsList': 'getDoctorsList',
    'createDoctor': 'createDoctor',
    'getPrivileges': 'getPrivileges',
    'getDoctorSpecialities': 'getDoctorSpecialities',
    'viewRolePermissions': 'viewRolePermissions',
    'getUserDetailsById': 'getUserDetailsById',
    'getDoctorIdDetails': 'getDoctorIdDetails',
    'updateUserDetailsById': 'updateUserDetailsById',
    'updateRole': 'updateRole',
    'getPrivilegesList': 'getPrivilegesList',
    'createPrivilegesList': 'createPrivilegesList',
    'editPrivilegesbyid': 'editPrivilegesbyid',
    'getPrivilegesbyid': 'getPrivilegesbyid',
    'disableprivilegebyid': 'disableprivilegebyid',
    'getPatientDetailsForQueue': 'getPatientDetailsForQueue',
    'generateTokenForQueue': 'generateTokenForQueue',
    'assignTokenToCounsellor': 'assignTokenToCounsellor',
    'nextPatientforQueue': 'nextPatientforQueue',
    'skipPatientfromQueue': 'skipPatientfromQueue',
    'getconfigurations': 'getconfigurations',
    'disableconfigurationsbyid': 'disableconfigurationsbyid',
    'updateConfigBilltrack': 'updateConfigBilltrack',
    'getProfileDetails': 'getProfileDetails',
    'changeProfilePassword': 'changeProfilePassword',
    'sendOTP': 'sendOTP',
    'checkOTP': 'checkOTP',
    'updatePassword': 'updatePassword',
    'getProcedures': 'getProcedures',
    'getCashNonPackageRoomsByUnitId': 'getCashNonPackageRoomsByUnitId',
    'getCounsellingsList': 'getCounsellingsList',
    'createFinancialCouncelling': 'createFinancialCouncelling',
    'getAllInsuranceCompanies': 'getAllInsuranceCompanies',
    'getAllTpas': 'getAllTpas',
    'getPreExistingConditions': 'getPreExistingConditions',
    'getRoomUpgradeReasons': 'getRoomUpgradeReasons',
    'getCounsellingType': 'getCounsellingType',
    'getConusellingDetails': 'getConusellingDetails',
    'saveOtherCounsellings': 'saveOtherCounsellings',
    'getMasterAilmentCappingStatusOptions': 'getMasterAilmentCappingStatusOptions',
    'getMasterSumInsuredFourYearsBackOptions': 'getMasterSumInsuredFourYearsBackOptions',
    'getMasterInsuranceTypes': 'getMasterInsuranceTypes',
    'getMasterInsuranceStatus': 'getMasterInsuranceStatus',
    'getMasterPatientTypes': 'getMasterPatientTypes',
    'getMasterPreAuthStatus': 'getMasterPreAuthStatus',
    'getMasterCareManagement': 'getMasterCareManagement',
    'getMasterEstimateTypes': 'getMasterEstimateTypes',
    'getCounsellingSkipReasons': 'getCounsellingSkipReasons',
    'getPackagesForDropDown': 'getPackagesForDropDown',
    'getPackagesPricesById': 'getPackagesPricesById',
    // 'getNonPackagePrices':'getNonPackagePrices',
    'getNonPackagePrices': 'getInsuranceNonPackagePrices',
    'startAssignTokenToCounsellor': 'startAssignTokenToCounsellor',
    'nextAssignTokenToCounsellor': 'nextAssignTokenToCounsellor',
    'getTVdisaplayTokenswithNoAuth': 'getTVdisaplayTokenswithNoAuth',
    'logout': 'logout',
    'getTokenTatReport': 'getTokenTatReport',
    'getRecounsellingReport': 'getRecounsellingReport',
    'getBillTrackingReport': 'getBillTrackingReport',
    'getBillTrackingDetails': 'getBillTrackingDetails',
    'getPlannedAdmissionsReport': 'getPlannedAdmissionsReport',
    'getEstimateVarianceReport': 'getEstimateVarianceReport',
    'getBillHeaderWiseReport': 'getBillHeaderWiseReport',
    'getBreaktimeReasons': 'getBreaktimeReasons',
    'takeAbreakforCounsellor': 'takeAbreakforCounsellor',
    'getIdleTatReport': 'getIdleTatReport',
    'checkTokenforAssign': 'checkTokenforAssign',
    'getWaitingTokensforManager': 'getWaitingTokensforManager',
    'getUsersByPrivilegeIds': 'getUsersByPrivilegeIds',
    'assignTokenToCounsellorFromManager': 'assignTokenToCounsellorFromManager',
    'getDoctorsforDropdown': 'getDoctorsforDropdown',
    'getDashboardCardsInfo': 'getDashboardCardsInfo',
    'getServiceWiseWaitingList': 'getServiceWiseWaitingList',
    'getServiceWiseTatReport': 'getServiceWiseTatReport',
    'getServiceWiseLiveCountReport': 'getServiceWiseLiveCountReport',
    'getBillTrackingTatReport': 'getBillTrackingTatReport',
    'changeUserStatus': 'changeUserStatus',
    'getCounsellingStations': 'getCounsellingStations',
    'changeCounsellingStationStatus': 'changeCounsellingStationStatus',
    'addCounsellingStation': 'addCounsellingStation',
    'getCounsellingPrintDetails': 'getCounsellingPrintDetails',
    'getTokensForTG': 'getTokensForTG',
    'cancelToken': 'cancelToken',
    'recallToken': 'recallToken',
    'getDepartmentsFromPatients': 'getDepartmentsFromPatients',
    'getNurseStationDropdownFromPatients': 'getNurseStationDropdownFromPatients',
    'changeUserTVdisplayStatus': 'changeUserTVdisplayStatus',
    'getMasterDocumentTypes': 'getMasterDocumentTypes',
    'getPatientDocumentDetails': 'getPatientDocumentDetails',
    'removePatientDocument': 'removePatientDocument',
    'enableFileUpload': 'enableFileUpload',
    'disableFileUpload': 'disableFileUpload',
    'getPatientsList': 'getPatientsList',
    'getPatientHistory': 'getPatientHistory',
    'getDocumentPendingPatientsList': 'getDocumentPendingPatientsList',
    'checkTokenforBreak': 'checkTokenforBreak',
    'downloadPatientDocumentsAsPDF': 'downloadPatientDocumentsAsPDF',
    'getDueOutstandingReport': 'getDueOutstandingReport',
    'getDocumentsReport': 'getDocumentsReport',
    'getDepartmentsFromDoctors': 'getDepartmentsFromDoctors',
    'addSMSExcludeDepartments': 'addSMSExcludeDepartments',
    'addCounsellorComments': 'addCounsellorComments',
    'getCounsellorCommentsByPatient': 'getCounsellorCommentsByPatient',
    'getOnbedPatientsForNurse': 'getOnbedPatientsForNurse',
    'getMasterServicesForNurse': 'getMasterServicesForNurse',
    'getMasterProceduresForNurse': 'getMasterProceduresForNurse',
    'getMasterDrugsForNurse': 'getMasterDrugsForNurse',
    'getConsentsListForPatient': 'getConsentsListForPatient',
    'saveConsentNurseRequest': 'saveConsentNurseRequest',
    'getConsentsDetailsForPatient': 'getConsentsDetailsForPatient',
    'getConsentPatientsList': 'getConsentPatientsList',
    'getConsentsDetailsForPatient': 'getConsentsDetailsForPatient',
    'consentSubmitFromCounsellor': 'consentSubmitFromCounsellor',
    'getFinancialClearanceDetails': 'getFinancialClearanceDetails',
    'addFinancialClearance': 'addFinancialClearance',
    'getConsentRejectReasons': 'getConsentRejectReasons',
    'getPlannedAdmissionsWorklist': 'getPlannedAdmissionsWorklist',
    'getRemarksReport': 'getRemarksReport',
    'updateFinancialClearanceinOTMApp': 'updateFinancialClearanceinOTMApp',
    'getPatientDischargeInitiationInfo': 'getPatientDischargeInitiationInfo',
    'getPatientTrackbillInfo': 'getPatientTrackbillInfo',
    'addCounsellorComments': 'addCounsellorComments',
    'getCounsellingDetailsByIP': 'getCounsellingDetailsByIP',
    'getNurseStationDashboardInfo': 'getNurseStationDashboardInfo',
    'getCounsellingStationsDropDown': 'getCounsellingStationsDropDown',
    'getCounsellorTypes': 'getCounsellorTypes',
    'stationTvDisplay': 'tv-display?csid=',
    'getCounsellingStationDetails': 'getCounsellingStationDetails',
    'updateCounsellingStation': 'updateCounsellingStation',
    'getMasterCabins': 'getMasterCabins',
    'saveCabinIDInUser': 'saveCabinIDInUser',
    'getPaymentTypes': 'getPaymentTypes',
    'getServicesByHeaderId': 'getServicesByHeaderId',
    'getServicePricesById': 'getServicePricesById',
    'getCashPackagePricesById': 'getCashPackagePricesById',
    'getUsersListFull': 'getUsersListFull',
    'getFcDetails': 'getFcDetails',
    'getInsuranceNonPackageRoomsByUnitId': 'getInsuranceNonPackageRoomsByUnitId',
    'getInsurancePackagePricesById': 'getInsurancePackagePricesById',
    'getMasterNMEs': 'getMasterNMEs',
    'getroomNamesonImages': 'getroomNamesonImages',
    'getallroomImages': 'getallroomImages',
    'getPreExistingConditions': 'getPreExistingConditions',
    'updateTokenCheckin': 'updateTokenCheckin',
    'getRemedinetPayerlist': 'getRemedinetPayerlist',
    'getRemedinetZoneslist': 'getRemedinetZoneslist',
    'getRemedinetInsurancesCompanyList': 'getRemedinetInsurancesCompanyList',
    'getPreauthWorklist': 'getPreauthWorklist',
    'submitPreauth': 'submitPreauth',
    'getNurseStationsWithNoAuth': 'getNurseStationsWithNoAuth',
    'getSurgeriesWorklist': 'getSurgeriesWorklist',
    'getUsersForTokenGenerator': 'getUsersForTokenGenerator',
    'getEstimateHeadersDropdown': 'getEstimateHeadersDropdown',
    'getEstimateSubHeadersDropdown': 'getEstimateSubHeadersDropdown',
    'getMasterEstimate': 'getMasterEstimate',
    'getMasterRoom': 'getMasterRoom',
    'getMasterInvestigations': 'getMasterInvestigations',
    'getMasterIncludes': 'getMasterIncludes',
    'getMasterExclude': 'getMasterExclude',
    'getMasterDrugs': 'getMasterDrugs',
    'getMasterConsentProcedures': 'getMasterConsentProcedures',
    'getMasterNme': 'getMasterNme',
    'getMasterTpasAndInsurnaceCompanies': 'getMasterTpasAndInsurnaceCompanies',
    'getMasterPackages': 'getMasterPackages',
    'getMasterService': 'getMasterService',
    'getMasterRoomImages': 'getMasterRoomImages',
    'getMasterTariffs': 'getMasterTariffs',
    'getRemedinetPayerHistory':'getRemedinetPayerHistory',
    'getInterimEnhancementsWorklist':'getInterimEnhancementsWorklist',
    'getActiveUsersforManager':'getActiveUsersforManager',
    'getCashPackagePricesByProcedureName':'getCashPackagePricesByProcedureName',
    'getInsurancePackagePricesByProcedureName':'getInsurancePackagePricesByProcedureName',
    'getActiveCounsellors':'getActiveCounsellors',
    'getLatestCounsellingIdForPatient':'getLatestCounsellingIdForPatient',
    'addICUTaggedDepartments':'addICUTaggedDepartments',
    'getCallLogCategories':'getCallLogCategories',
    'getCallLogCategoryReasons':'getCallLogCategoryReasons',
    'getEstimateVarianceWorklist':'getEstimateVarianceWorklist',
    'checkDuplicateDoctor':'checkDuplicateDoctor',
    'getMasterconsutations':'getMasterconsutations',
    'getConsentsDropDownForPatient':'getConsentsDropDownForPatient',
    'createUserMail':'createUserMail',
    'deleteMail':'deleteMail',
    'getCounsellingStationsByUser':'getCounsellingStationsByUser',
    'getLogReport':'getLogReport',
    "digitalSignaturUpload": "digitalSignaturUpload",
    "getDashboardCountForWorklists": "getDashboardCountForWorklists",
    "getBreakTimeReasonsList": "getBreakTimeReasonsList",
    "updateBreakTimeandBreakCount": "updateBreakTimeandBreakCount",
    "sendDigitalSignLink": "sendDigitalSignLink",
    "getDigitalSignInfoByToken": "getDigitalSignInfoByToken",
    'saveFCChecklist':'saveFCChecklist',
    'updateFCChecklist':'updateFCChecklist',
    'getAdmissionAdvises':'getAdmissionAdvises',
    'insertPatientDiscountRequest':'insertPatientDiscountRequest',
    'getPatientDiscountRequest':'getPatientDiscountRequest',
    'getWardsDropdownFromPatients':'getWardsDropdownFromPatients',
    'getTrackBillStatuses':'getTrackBillStatuses',
    'getNurseStationDashboardInfoFromRedis':'getNurseStationDashboardInfoFromRedis',
    'validateMobileNumberForDigitalSign':'validateMobileNumberForDigitalSign',
    'acceptCounsellingPreview':'acceptCounsellingPreview',
    'getPatientWilling':'getPatientWilling',
    'insertMasterNmeList':'insertMasterNmeList',
    'getMasterNmeList': 'getMasterNmeList',
    'getMasterNmeListByUnitid': 'getMasterNmeListByUnitid',
    'updateMasterNmeList': 'updateMasterNmeList',
    'insertPatientDiscountRequest':'insertPatientDiscountRequest',
    'getUploadPatientsDocumentsDetails' : 'getUploadPatientsDocumentsDetails',
    'homepage':'',
    'ui_base_url':(IS_PRODUCTION)?'https://fc.kimshospitals.com':'https://testfc.kimshospitals.com',
    'getProceduresforFCApp': 'getProceduresforFCApp'
}

export default networkList;